export default {
  configs: {},

  selectedBreakdownId: '',

  breakdowns: {},
  breakdownsData: {},
  breakdownsAttributes: [],

  geos: [],
  primaryGeo: {},
  secondaryGeo: {},

  args: {},

  geoType: null,
  geoSection: {},

  isLoading: false,
  isDownloadLoading: false,
  hasLoaded: false,

  activeGeoType: null,
};
